var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #b4b4b4;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.25px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipColumn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LayerColumn"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.23 11.48 24.53 11.31 22.6 10.61 25.24 9.14 27.17 9.83 27.47 9.66 23.38 8.19 23.07 8.36 25 9.05 22.37 10.53 20.43 9.84 20.13 10 24.23 11.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.07 10.13 25 9.05 23.07 8.36 23.07 10 23.07 10.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.23 40.15 24.23 11.48 20.13 10 20.13 38.67 24.23 40.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.23 40.15 24.53 39.98 24.53 11.31 24.23 11.48 24.23 40.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "24.53 38.2 25.24 37.8 25.2 9.16 22.6 10.61 24.53 11.31 24.53 11.48 24.53 38.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.17 38.5 27.17 9.83 25.24 9.14 25.24 37.8 27.17 38.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.17 38.5 27.47 38.33 27.47 9.66 27.17 9.83 27.17 38.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27.47,
    y1: 9.66,
    x2: 23.37,
    y2: 8.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.37,
    y1: 8.19,
    x2: 23.07,
    y2: 8.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.07,
    y1: 8.36,
    x2: 25,
    y2: 9.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25,
    y1: 9.05,
    x2: 22.37,
    y2: 10.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.37,
    y1: 10.53,
    x2: 20.44,
    y2: 9.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.44,
    y1: 9.84,
    x2: 20.13,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.13,
    y1: 10,
    x2: 24.23,
    y2: 11.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.23,
    y1: 11.48,
    x2: 24.53,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.53,
    y1: 11.31,
    x2: 22.6,
    y2: 10.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.6,
    y1: 10.61,
    x2: 25.24,
    y2: 9.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25.24,
    y1: 9.14,
    x2: 27.17,
    y2: 9.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27.17,
    y1: 9.83,
    x2: 27.47,
    y2: 9.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 27.47,
    y1: 38.33,
    x2: 27.17,
    y2: 38.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 27.17,
    y1: 38.5,
    x2: 25.24,
    y2: 37.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 25.24,
    y1: 37.8,
    x2: 24.53,
    y2: 38.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.53,
    y1: 39.98,
    x2: 24.23,
    y2: 40.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.23,
    y1: 40.14,
    x2: 20.13,
    y2: 38.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27.47,
    y1: 9.66,
    x2: 27.47,
    y2: 38.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.07,
    y1: 10.13,
    x2: 23.07,
    y2: 8.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 20.13,
    y1: 38.67,
    x2: 20.13,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.23,
    y1: 40.14,
    x2: 24.23,
    y2: 11.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.53,
    y1: 39.98,
    x2: 24.53,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25.24,
    y1: 37.8,
    x2: 25.24,
    y2: 9.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27.17,
    y1: 38.5,
    x2: 27.17,
    y2: 9.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipColumn);
export default __webpack_public_path__ + "static/media/IconChipColumn.fae85ed4fa33bcd9825114888dec369e.svg";
export { ForwardRef as ReactComponent };